import type { h } from 'preact';
import { SVGProps } from '@components/icons';

export function CommunityNavLink(props: {
  isSelected: boolean;
  href: string;
  name: string;
  isExternal?: boolean;
  onClick?: () => void;
  Icon(p: SVGProps): h.JSX.Element;
}) {
  return (
    <li class="relative">
      {props.isSelected && (
        <span class="absolute inset-y-0 -left-2 w-[3px] rounded-tr-xl rounded-br-xl bg-indigo-600"></span>
      )}
      <a
        href={props.href}
        class={`group flex items-center gap-x-3 rounded-md px-4 py-2 text-sm/6 ${
          props.isSelected
            ? 'text-indigo-600 dark:text-indigo-400 font-semibold'
            : 'text-gray-800 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800 hover:text-indigo-600 dark:hover:text-indigo-400'
        }`}
        target={props.isExternal ? '_blank' : undefined}
        rel={props.isExternal ? 'noopener noreferrer' : undefined}
        onClick={props.onClick}
      >
        <props.Icon
          class={`h-5 w-5 shrink-0 ${
            props.isSelected ? 'text-indigo-600' : 'text-gray-400 group-hover:text-indigo-600'
          }`}
        />
        {props.name}
      </a>
    </li>
  );
}
